import React, { Component, useContext, useState } from "react"
import { Card, Button, Alert, Image } from "react-bootstrap"
import { AuthContext } from '../../contexts/AuthContext'
import { Link, useNavigate } from "react-router-dom"
import Navbar from "../layout/Navbar"
import Notifications from "./Notifications"
import EntityList from "../entities/EntityList"
import { connect } from 'react-redux'
import { useSelector } from "react-redux"
import { firebaseConnect, firestoreConnect, useFirebase, useFirebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { query, where } from 'firebase/firestore'
import { styles } from '../layout/styles'

function Dashboard(props) {
    const entities = props.entities;
    const wellness = props.wellness;
    // console.log(entities);
    // console.log(wellness);
    if (!entities) {
      return (
        <div>No children added! Please add your child's information </div>
      )
    } else {
      return (
        <>
        <div style={styles.MainBGDiv}>
          <div style={styles.DashboardContainer}>
            <div style={{display:'flex', flexDirection:"row"}}>
                <div style={{flex:'3', margin:'10px', minWidth:'60%'}}>
                  <EntityList entities={entities} wellness={wellness}/>
                </div>
                {/* <div style={{flex:'4', margin:'25px', width:'100px', height:'660px'}}>
                  <Card style={{ alignContent:'center', alignItem:'center', justifyContent: "center",  }}>
                      <Card.Body>
                          <Card.Title> 
                          <div style={{display:'flex', flexDirection:"row"}}>
                              <div style={{flex:'1', minWidth:'40%', height:'650px'}}>
                                <Image style={{width:'100%', height:'100%'}} src={process.env.PUBLIC_URL + '/images/ShoppingCart.png'} fluid rounded/>
                              </div>
                          </div>                                                                
                          </Card.Title>
                          <Card.Text>
                          </Card.Text>
                      </Card.Body>
                  </Card>
                </div> */}
                {/* <div style={{margin:'10px', width:'5%', height:'300px', backgroundColor:'orange'}}>3</div> */}
            </div>
          </div>
        </div>

        </>
      )
    }
} 

const mapStateToProps = (state) => {
  //console.log(state);
  const ownentities = state.firestore.ordered.entities ? state.firestore.ordered.entities : state.entity.entities;
  const ownwellness = state.firestore.ordered.wellness ? state.firestore.ordered.wellness : [];
  //console.log(ownentities);
  //console.log(ownwellness);
  return {
    entities: ownentities,
    wellness: ownwellness,
    auth: state.firebase.auth
  }
}

export default compose(
  firebaseConnect(),
  connect(mapStateToProps),
  firestoreConnect(state => {
    const puid = (state.auth.uid != undefined) ? state.auth.uid : 'blank user';
    //console.log(puid);
    return [
      { 
        collection: 'entities',
        where: ['createdbyuser', '==', puid],
        // subcollections: [ {
        //   collection: 'wellness',
        //   orderBy: ["createddate", 'desc'],
        // },          
        // ]
        // collection: 'wellness',
        // where: ['createdbyuser', '==', puid],
        //orderBy: ['firstname', 'desc']
      },
      { 
        collection: 'wellness',
        where: ['createdbyuser', '==', puid],
      },

      ]  
    }
  ),
  )(Dashboard)


